module.exports = __webpack_public_path__ + "img/logo-eurosport.2abd00df.jpg";